import React, { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import PopConso from "../../ressources/images/popConso.png";
import * as timeToolbox from "../../ressources/tools/utils";
import { ConsoResponseWithYearlyAverage } from "../../typings/types";
import Histogram from "../../views/Graph/Histogram";
import SemiCircleGauge from "../../views/Graph/SemiCircleGauge";

const Consommation = ({
  consommation,
  uniteTemps,
  carburant,
  maxDebit,
}: {
  consommation: ConsoResponseWithYearlyAverage;
  uniteTemps: number;
  carburant: string;
  maxDebit: number;
}) => {
  const {
    x,
    t,
    debit_general,
    max_debit_general,
    min_debit_general,
    engineering_unit,
    yearlyAverage,
  } = consommation;
  const [ticks, setTicks] = useState<string[]>([]);
  const [hasValidData, setHasValidData] = useState(true);
  const [adjustedValuesConsommation, setAdjustedValuesConsommation] = useState<
    number[]
  >([]);

  // Novo estado para controlar a exibição da popup
  const [showPopup, setShowPopup] = useState(false);

  // Função para verificar se o valor é válido

  useEffect(() => {
    setHasValidData(t?.length > 0 && x?.length > 0 && maxDebit !== 0);
  }, [t, x, maxDebit]);

  // Atualiza os "ticks" com base no tipo de unidade de tempo
  useEffect(() => {
    setTicks(timeToolbox.utsToTicks(t, uniteTemps));
  }, [t, uniteTemps]);

  useEffect(() => {
    setAdjustedValuesConsommation(x); // Mantém os valores originais se não houver fator
  }, [x]);
  // Verifica se os dados são inválidos e renderiza o botão de aviso
  if (!hasValidData) {
    return (
      <button className="btnMsg">
        Pas de données enregistrées pour cette période. Essayez une autre plage
        de dates !
      </button>
    );
  }

  // Função para lidar com o clique no botão
  const handleClick = () => {
    setShowPopup(true);
  };
  return (
    <div className="tab-content">
      <div className={"config-group"}>
        <div className="input-group">
          <span className="newcss">
            <SemiCircleGauge
              value={debit_general ? Math.round(debit_general * 100) / 100 : 0}
              unite={engineering_unit}
              max={max_debit_general}
              min={min_debit_general}
              color="#4194D0"
              backgroundColor="#D9D9D9"
              textColor="#000000"
            />
          </span>
        </div>
        <div className="input-group">
          <Histogram
            unite={engineering_unit}
            dates={ticks}
            values={adjustedValuesConsommation}
            moyenneAnnee={yearlyAverage}
          />
        </div>
        <button className="conseil newconseil" onClick={handleClick}>
          Afficher la légende
        </button>

        {/* Renderiza a popup se showPopup for true */}
        {showPopup && (
          <div className="backBluer">
            <div className="popup nwspopup">
              <div className="popup-content">
                <span className="Nclose" onClick={() => setShowPopup(false)}>
                  {" "}
                  <AiOutlineClose
                    className={"close-icon"}
                    aria-label={"close-icon"}
                  />
                </span>
                <img src={PopConso} className={"npopup"} alt={"Legende"} />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Consommation;
